import { mount } from 'svelte'
import FlashMessages from '../components/FlashMessages.svelte'
import SignupForm from '../components/SignupForm.svelte'
import DayFooter from '../components/DayFooter.svelte'

const components = {
  'flash-messages': FlashMessages,
  'signup-form': SignupForm,
  'day-footer': DayFooter,
}

document.querySelectorAll('[data-svelte]').forEach((el) => {
  const name = el.dataset.svelte
  const Component = components[name]
  if (Component) {
    const props = JSON.parse(el.dataset.svelteProps || '{}')
    mount(Component, { target: el, props })
  }
})
